import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import fetteLogo from "../assets/fette-logo.svg";
import uptimeLogo from "../assets/247uptime-logo.svg";

export const FETTE_PREFIX = "/fette";

export const ACCESS_THEME = {
  mode: "access",
  primary: "#0E3F51",
  primaryRgb: "14, 63, 81",
  secondary: "#38748D",
  secondaryRgb: "56, 116, 141",
  logo: uptimeLogo,
  logoAlt: "247Access Logo",
  logoWidth: null,
  tab:"#0E3F51"
};

export const FETTE_THEME = {
  mode: "fette",
  primary: "#009CB4",
  primaryRgb: "0, 156, 180",
  secondary: "#3C4559",
  secondaryRgb: "60, 69, 89",
  logo: fetteLogo,
  logoAlt: "Fette Logo",
  logoWidth: "56%",
  tab:"#000000"
};

export const isFettePath = (pathname = "") =>
  pathname === FETTE_PREFIX || pathname.startsWith(`${FETTE_PREFIX}/`);

export const stripFettePrefix = (pathname = "") => {
  if (!isFettePath(pathname)) {
    return pathname;
  }

  const strippedPath = pathname.slice(FETTE_PREFIX.length);
  return strippedPath || "/";
};

export const withAccountPrefix = (path, pathname = "") => {
  if (!path || !path.startsWith("/")) {
    return path;
  }

  if (!isFettePath(pathname) || isFettePath(path)) {
    return path;
  }

  return path === "/" ? FETTE_PREFIX : `${FETTE_PREFIX}${path}`;
};

export const withCurrentAccountPrefix = (path) =>
  withAccountPrefix(path, window.location.pathname);

export const getDualRoutePath = (path) => {
  if (path === "*") {
    return `${FETTE_PREFIX}/*`;
  }

  return withAccountPrefix(path, FETTE_PREFIX);
};

export const getAccountTheme = (pathname = "") =>
  isFettePath(pathname) ? FETTE_THEME : ACCESS_THEME;

export const applyAccountTheme = (pathname = "") => {
  const root = document.documentElement;
  const theme = getAccountTheme(pathname);

  root.dataset.accountMode = theme.mode;
  root.style.setProperty("--color-primary", theme.primary);
  root.style.setProperty("--color-primary-rgb", theme.primaryRgb);
  root.style.setProperty("--color-secondary", theme.secondary);
  root.style.setProperty("--color-secondary-rgb", theme.secondaryRgb);
  root.style.setProperty("--Primary-800", theme.primary);
  root.style.setProperty("--Secondary-500", theme.secondary);
  root.style.setProperty("--tab", theme.tab);
};

export const useAccountMode = () => {
  const location = useLocation();

  return useMemo(() => {
    const theme = getAccountTheme(location.pathname);

    return {
      isFette: theme.mode === "fette",
      theme,
      prefixPath: (path) => withAccountPrefix(path, location.pathname),
    };
  }, [location.pathname]);
};
